import React from "react";

import type { IGenericBaseModel } from "models/shared/GenericBaseModel";
import { PageModel, type IPageModel } from "models/flow/PageModel";

/**
 * Interface para o modelo de associação entre um Fluxo e uma Página (FlowPage).
 */
export interface IFlowPageModel extends IGenericBaseModel {
  page: IPageModel;
  ordering: number;
}

/**
 * Classe que representa a associação entre um Fluxo e uma Página.
 */
export class FlowPageModel implements IFlowPageModel {
  uuid?: string;
  key?: React.Key;
  page: PageModel;
  ordering: number;

  constructor(data: IFlowPageModel) {
    this.uuid = data?.uuid;
    this.key = data?.uuid;
    this.page = new PageModel(data.page);
    this.ordering = data?.ordering ?? 0;
  }
}